import { render, staticRenderFns } from "./cancelTab.vue?vue&type=template&id=261ea672&scoped=true&"
import script from "./cancelTab.vue?vue&type=script&lang=js&"
export * from "./cancelTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261ea672",
  null
  
)

export default component.exports